import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert, Badge } from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FaPlus, FaRegEdit, FaTimes, FaSpinner, FaCheck, FaListUl } from "react-icons/fa";
import { formataDataExibicao, formataDataHoraExibicao, hasPerm } from "../../common/utils";

const voucherVazio = { id: null, codigo: '', descricao: '', limite_uso: '', data_limite: '', status: true };

class VouchersPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programa_id: this.props.programa_id,
            vouchers: [],
            loading: false,
            erroLoadRegistro: '',
            // modal cadastro/edição
            showModal: false,
            loadingModal: false,
            modalTitulo: 'Cadastrar Voucher',
            voucherEdit: { ...voucherVazio },
            // modal de logs de uso (utilizações)
            showLogs: false,
            loadingLogs: false,
            logsVoucher: null,
            logsUtilizacoes: [],
            // prefixo do código automático (configuracoes.vouchers.prefixo_codigo do programa)
            configuracoesPrograma: null,
            prefixo_codigo: '',
            salvandoPrefixo: false,
        };
    }

    componentDidMount() {
        this.carregarVouchers();
        this.carregarConfigPrograma();
    }

    carregarConfigPrograma = async () => {
        if (!this.state.programa_id) return;

        try {
            const response = await api.get(`/programas/${this.state.programa_id}/`);
            const configuracoes = response.data?.configuracoes || {};
            this.setState({
                configuracoesPrograma: configuracoes,
                prefixo_codigo: configuracoes?.vouchers?.prefixo_codigo || '',
            });
        } catch (error) {
            // sem a config o cadastro segue funcionando (código aleatório) — só loga
            console.error('Erro ao carregar as configurações do programa:', error);
        }
    };

    salvarPrefixo = async () => {
        const prefixo = (this.state.prefixo_codigo || '').trim().toUpperCase();
        const configuracoes = { ...(this.state.configuracoesPrograma || {}) };
        const vouchersCfg = { ...(configuracoes.vouchers || {}) };

        if (prefixo) {
            vouchersCfg.prefixo_codigo = prefixo;
        } else {
            delete vouchersCfg.prefixo_codigo;
        }
        configuracoes.vouchers = vouchersCfg;

        this.setState({ salvandoPrefixo: true });
        try {
            await api.put(`/programas/${this.state.programa_id}/`, {
                configuracoes,
                confirmar_alteracoes_configuracoes: true,
            });

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>{prefixo ? `Prefixo "${prefixo}" salvo. Novos vouchers sem código receberão ${prefixo}-ANO-sequência.` : 'Prefixo removido. Novos vouchers sem código receberão código aleatório.'}</p>,
                icon: 'success',
                showCloseButton: true,
            });
            this.setState({ configuracoesPrograma: configuracoes, prefixo_codigo: prefixo });
        } catch (error) {
            console.error('Erro ao salvar o prefixo do voucher:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({ icon: 'error', showCloseButton: true, title: <p>Erro ao salvar o prefixo, tente novamente</p> });
        } finally {
            this.setState({ salvandoPrefixo: false });
        }
    };

    carregarVouchers = async () => {
        if (!this.state.programa_id) return;

        this.setState({ loading: true, erroLoadRegistro: '' });
        try {
            const response = await api.get(`/vouchers/?programa_id=${this.state.programa_id}&status=1&limit=200`);
            const vouchers = (response.data.results || []).map(v => ({
                id: v.id,
                codigo: v.codigo ?? '',
                descricao: v.descricao ?? '',
                limite_uso: v.limite_uso ?? '',
                data_limite: v.data_limite ?? '',
                status: v.status,
                quantidade_usos: v.quantidade_usos ?? 0,
            }));
            this.setState({ vouchers });
        } catch (error) {
            console.error('Erro ao carregar vouchers:', error);
            let erro_msg = 'Erro ao carregar vouchers do programa, tente novamente';
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento, tente novamente';
            }
            this.setState({ erroLoadRegistro: erro_msg });
        } finally {
            this.setState({ loading: false });
        }
    };

    abrirModalNovo = () => {
        this.setState({ showModal: true, modalTitulo: 'Cadastrar Voucher', voucherEdit: { ...voucherVazio } });
    };

    abrirModalEditar = (voucher) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Voucher',
            voucherEdit: {
                id: voucher.id,
                codigo: voucher.codigo ?? '',
                descricao: voucher.descricao ?? '',
                limite_uso: voucher.limite_uso ?? '',
                data_limite: voucher.data_limite ?? '',
                status: voucher.status,
            },
        });
    };

    fecharModal = () => {
        this.setState({ showModal: false });
    };

    handleChangeModal = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({ voucherEdit: { ...prevState.voucherEdit, [name]: value } }));
    };

    salvarVoucher = async () => {
        const voucher = this.state.voucherEdit;
        const url = voucher.id ? `/vouchers/${voucher.id}/` : '/vouchers/';
        const metodo = voucher.id ? 'put' : 'post';

        const dadosVoucher = {
            status: true,
            codigo: voucher.codigo,
            descricao: voucher.descricao,
            limite_uso: voucher.limite_uso !== '' ? voucher.limite_uso : null,
            data_limite: voucher.data_limite || null,
            programa_id: this.state.programa_id,
        };

        this.setState({ loadingModal: true });
        try {
            await api({ method: metodo, url, data: dadosVoucher });

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>{voucher.id ? 'Voucher atualizado com sucesso' : 'Voucher cadastrado com sucesso'}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ showModal: false });
            this.carregarVouchers();
        } catch (error) {
            let erro_msg = 'Erro ao cadastrar o voucher, verifique os campos e tente novamente';
            let content = '';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data || {};
                const rotulos = { codigo: 'Código', descricao: 'Descrição', limite_uso: 'Limite de uso', data_limite: 'Data limite', programa_id: 'Id do Programa' };
                for (let key in campos) {
                    if (rotulos[key]) content += `<br>&bull; ${rotulos[key]}: ${campos[key]}`;
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({ icon: 'error', showCloseButton: true, title: <p>{erro_msg}</p>, html: content });
        } finally {
            this.setState({ loadingModal: false });
        }
    };

    removerVoucher = (voucher) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Remover voucher?',
            text: "Tem certeza que deseja remover este voucher?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (!result.isConfirmed) return;

            api({ method: 'put', url: `/vouchers/${voucher.id}/`, data: { status: false } })
                .then(() => {
                    withReactContent(Swal).fire({ title: <p>Voucher removido com sucesso</p>, icon: 'success', showCloseButton: true });
                    this.carregarVouchers();
                })
                .catch(error => {
                    let erro_msg = 'Erro ao remover o voucher, tente novamente';
                    if (error.response && error.response.status === 500) erro_msg = 'Servidor indisponível no momento';
                    withReactContent(Swal).fire({ icon: 'error', showCloseButton: true, title: <p>{erro_msg}</p> });
                });
        });
    };

    abrirLogs = async (voucher) => {
        this.setState({ showLogs: true, loadingLogs: true, logsVoucher: voucher, logsUtilizacoes: [] });
        try {
            const response = await api.get(`/vouchers/${voucher.id}/`);
            this.setState({ logsUtilizacoes: response.data.dados_utilizacoes || [] });
        } catch (error) {
            console.error('Erro ao carregar logs do voucher:', error);
        } finally {
            this.setState({ loadingLogs: false });
        }
    };

    fecharLogs = () => {
        this.setState({ showLogs: false, logsVoucher: null, logsUtilizacoes: [] });
    };

    renderLinhas = () => {
        if (this.state.vouchers.length === 0) {
            return <tr><td colSpan={7}>Nenhum voucher cadastrado para este programa</td></tr>;
        }

        return this.state.vouchers.map((voucher) => (
            <tr key={voucher.id}>
                <td>
                    <span className="badge bg-success" style={{ fontSize: '0.9rem', letterSpacing: '1px' }}>{voucher.codigo}</span>
                </td>
                <td>{voucher.descricao || '-'}</td>
                <td>{voucher.limite_uso !== '' && voucher.limite_uso !== null ? voucher.limite_uso : 'Ilimitado'}</td>
                <td>
                    <Button variant="light" size="sm" onClick={() => this.abrirLogs(voucher)}>
                        <FaListUl className="me-1" /> {voucher.quantidade_usos} {voucher.quantidade_usos === 1 ? 'uso' : 'usos'}
                    </Button>
                </td>
                <td>{voucher.data_limite ? formataDataExibicao(voucher.data_limite) : 'Sem limite'}</td>
                <td><Badge bg={voucher.status ? 'success' : 'secondary'}>{voucher.status ? 'Ativo' : 'Inativo'}</Badge></td>
                <td>
                    <Button variant="light" size="sm" className="me-1" onClick={() => this.abrirModalEditar(voucher)}>
                        <FaRegEdit /> Editar
                    </Button>
                    <Button variant="outline-danger" size="sm" onClick={() => this.removerVoucher(voucher)}>
                        <FaTimes className="me-1" /> Remover
                    </Button>
                </td>
            </tr>
        ));
    };

    render() {
        const { loading, loadingModal, erroLoadRegistro, showModal, modalTitulo, voucherEdit, showLogs, loadingLogs, logsVoucher, logsUtilizacoes } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Vouchers do Programa</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Cadastrar Voucher
                                </Button>
                            </Col>
                        </Row>

                        {erroLoadRegistro ? <Alert variant="warning">{erroLoadRegistro}</Alert> : ''}

                        {hasPerm('change_programas') && (
                            <Row className="align-items-end mb-3">
                                <Col sm={6} lg={4}>
                                    <Form.Group>
                                        <Form.Label className="mb-1">Prefixo do código automático</Form.Label>
                                        <Form.Control
                                            type="text"
                                            maxLength={10}
                                            placeholder="Ex.: CMGC"
                                            value={this.state.prefixo_codigo}
                                            onChange={(e) => this.setState({ prefixo_codigo: e.target.value.toUpperCase() })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} lg={8}>
                                    <Button variant="outline-secondary" size="sm" className="mb-1" onClick={this.salvarPrefixo} disabled={this.state.salvandoPrefixo}>
                                        {this.state.salvandoPrefixo ? <FaSpinner className="spinner-rotate" /> : <FaCheck />} Salvar prefixo
                                    </Button>
                                    <div className="text-muted" style={{ fontSize: '12px' }}>
                                        Com prefixo, vouchers criados sem código recebem <strong>{this.state.prefixo_codigo || 'PREFIXO'}-{new Date().getFullYear()}-001</strong> (sequência por ano). Sem prefixo, o código é aleatório.
                                    </div>
                                </Col>
                            </Row>
                        )}

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Limite de uso</th>
                                    <th>Usos</th>
                                    <th>Data limite</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={7} style={{ textAlign: 'center' }}><FaSpinner className="spinner-rotate" /> Buscando dados...</td></tr>
                                ) : this.renderLinhas()}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Código</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="codigo"
                                            maxLength={50}
                                            placeholder={this.state.prefixo_codigo
                                                ? `Em branco gera ${this.state.prefixo_codigo}-${new Date().getFullYear()}-sequência`
                                                : "Deixe em branco para gerar automaticamente"}
                                            value={voucherEdit.codigo}
                                            onChange={this.handleChangeModal}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Limite de uso</Form.Label>
                                        <Form.Control
                                            type="number"
                                            min={1}
                                            name="limite_uso"
                                            placeholder="Ilimitado"
                                            value={voucherEdit.limite_uso}
                                            onChange={this.handleChangeModal}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data limite</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="data_limite"
                                            value={voucherEdit.data_limite || ''}
                                            onChange={this.handleChangeModal}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="descricao"
                                            value={voucherEdit.descricao}
                                            onChange={this.handleChangeModal}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>Cancelar</Button>
                        <Button variant="success" onClick={this.salvarVoucher} disabled={loadingModal}>
                            {loadingModal ? <><FaSpinner className="spinner-rotate me-1" /> Salvando...</> : <><FaCheck className="me-1" /> Salvar</>}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Logs de Uso */}
                <Modal show={showLogs} onHide={this.fecharLogs} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Logs de uso {logsVoucher ? `— ${logsVoucher.codigo}` : ''}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loadingLogs ? (
                            <div style={{ textAlign: 'center' }}><FaSpinner className="spinner-rotate" /> Carregando...</div>
                        ) : logsUtilizacoes.length === 0 ? (
                            <Alert variant="light" className="mb-0">Nenhum uso registrado para este voucher.</Alert>
                        ) : (
                            <Table responsive size="sm" className="custom-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Atendimento</th>
                                        <th>Paciente</th>
                                        <th>Data de utilização</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logsUtilizacoes.map((u, idx) => (
                                        <tr key={u.id ?? idx}>
                                            <td>{u.atendimento_id ? `#${u.atendimento_id}` : '-'}</td>
                                            <td>{u.beneficiario_nome || '-'}</td>
                                            <td>{u.data_utilizacao ? formataDataHoraExibicao(u.data_utilizacao) : '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharLogs}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default VouchersPrograma;
